import React from 'react'
import { audioExtensions, videoExtensions, documentExtensions, imageExtensions, modelExtensions } from './data'
import { sortingArrowUpActive, sortingArrowDownActive, defaultSortingArrows, LightTooltip,
    imageAttachmentSmall, audioAttachmentSmall, pdfAttachmentSmall, videoAttachmentSmall, modelAttachmentSmall, unknownAttachment,
} from "./icons"
import moment from 'moment'

export const countEmbeddedFiles = (content) => {
    //searches for matches that meet all the following:
    // \!\[ = ![
    // .* any characters except line break zero or more times
    // ? indicates once or none (stops the search from extending to any additional ending "]" )
    // \. searches for a literal "."
    // \] = ]
    //entire search is enclosed in //
    const regex = new RegExp(/!\[.*?\.*\]/)
    let count = ((content || "").match(regex) || []).length
    return count
}

export const checkDevKeys = (keyCode, stateStatus, cb, cb2) => {
    if (keyCode === 68) {
        cb(1)
    } else if (keyCode === 69 && stateStatus === 1) {
        cb(2)
    } else if (keyCode === 86 && stateStatus === 2) {
        cb2()
    } else if (stateStatus > 0) {
           cb(0)
        } else {
            return
        }
}

export const replaceSpanWithTextInString = (content) => {

    let regex = new RegExp('<\s*span[^>]*>(.*?)<\s*\/\s*span>','g')
    let spanText = [...content.matchAll(regex)]
    for(let i = 0;i < spanText.length;i++){
        if(spanText[i][0].includes("TempHighlight")){
          content = content.replace(spanText[i][0],spanText[i][1])  
        }
        
    }
    return content
}

export const hasSpecialChar = (text) => {
    let regex = new RegExp(/[&~|\\\/\*\?:%&|#]/)
    if(regex.test(text)){
        return true
    }
    return false
}

export const getDateLocal = ()=>{
    let date = new Date()
    let dayOfWeek = null
    switch(date.getDay()){
        case 0:
            dayOfWeek = "Sun"
            break
        case 1:
            dayOfWeek = "Mon"
            break
        case 2:
            dayOfWeek = "Tues"
            break
        case 3:
            dayOfWeek = "Wed"
            break
        case 4:
            dayOfWeek = "Thur"
            break
        case 5:
            dayOfWeek = "Fri"
            break
        case 6:     
            dayOfWeek = "Sat"
            break
        default:
            dayOfWeek = "Unknown"
            break
    }
    const dayOfMonth = date.getDate()
    const month = date.getMonth()
    const year = date.getFullYear()
    const hour = date.getHours()
    const minute = date.getMinutes()

    return `${month + 1}/${dayOfMonth}/${year} ${hour}:${minute}`
}

export const getRegexSelection=(content,regexQ)=>{
        let con = content   
        let matchesAll = [...con.matchAll(regexQ)] 
        return matchesAll 
}

export const checkNotUndefindeNull = (obj) => typeof obj != "undefined" && obj != null;

// functions.js

export const SORT = (state, items, field, isBooleanData) => {
    if (checkNotUndefindeNull(items)) {
        if (isBooleanData) {
            // ... your existing boolean sorting logic ...
        } else {
            // Custom sorting logic for alpha || numeric
            if (state === 1 || state === 2) {
                return items.sort((a, b) => {
                    const valueA = a[field]
                    const valueB = b[field]
                    if (state === 1) {
                        if (valueA > valueB) { return -1; }
                        if (valueA <= valueB) { return 1; }
                    } else if (state === 2) {
                        if (valueA > valueB) { return 1; }
                        if (valueA <= valueB) { return -1; }
                    }
                    return 0;
                });
            }
            if (state === -2) {
                return items.sort((a, b) => {
                    if (a[field] < b[field]) { return 1; }
                    if (a[field] >= b[field]) { return -1; }
                    return 0;
                });
            } else if (state === -1) {
                items = items.sort((a, b) => {
                    if (a[field] < b[field]) { return -1; }
                    if (a[field] >= b[field]) { return 1; }
                    return 0;
                });
            }
        }
    }
    return items;
};


export const renderSortingIcon = (sortingState) => {

    // if (contentType === "other-reverse") {
    //     switch (sortingState) {
    //         case -1:
    //             return sortingArrowDownActive
    //         case -2:
    //             return sortingArrowUpActive
    //         default:
    //             return defaultSortingArrows
    //     }
    // } else {
        switch (sortingState) {
            case 1:
                return sortingArrowUpActive
            case 2:
                return sortingArrowDownActive
            default:
                return defaultSortingArrows
        }
    // }
}

export const renderDeviceIcon = (type, inProfilePage, cb) => {
let icon
switch (type) {
    case "tablet":
        icon = < i id="device-icon" className={`fas fa-tablet-alt ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    case "laptop":
        icon = < i id="device-icon" className={`fas fa-laptop ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    case "mobile":
        icon = < i id="device-icon" className={`fas fa-mobile-alt ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    case "desktop":
        icon = <i id="device-icon" className={`fas fa-desktop ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    case "vr":
        icon = <i id="device-icon" className={`fas fa-vr-cardboard ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    default:
        icon = <i id="device-icon" className={`far fa-question-circle ${inProfilePage ? "clickable" : ""}`} onClick={inProfilePage ? cb : null}></i>
        break
    }    
   if (inProfilePage) {
    return <LightTooltip title="Edit Device Type Icon" aria-label="Edit Device Type Icon" placement="top" enterDelay={500} enterNextDelay={500}>
        {icon}
    </LightTooltip>
   } else {
       return icon
   }
}
export const renderAuthorizationIcon = (authorization) => {
    switch (authorization) {
        case 1:
            return <i className="far fa-check-circle">Whitelisted Device</i>
        case -1: 
            return <i className="fas fa-ban">Device</i>
        default : 
            return <i className="fas fa-key">Waiting Authorization</i>
            // return <i className="fas fa-stopwatch">Waiting Authorization</i>
    }
}

//renders a progress bar in Model Uploader File Manager Component
// export const modelUploadProgressBars = (text, progress) => (
//      <div id="progress-bars-container" className="flex-centered" style={{width: '80%', marginRight: '1em'}}>
//         {text ? <span id="file-manager-item-progress">{text}</span> : null}
//         {(progress || progress === 0) ? <div className="flex max-width">
//             <div id="progress-bars" className="max-width">
//                 <div id="total-progress-bar" className="max-width">
//                     <div id="actual-progress-bar" style={{ borderTop: `.1875em solid blue`, width: `${progress}%` }}></div>
//                 </div>
//             </div>
//         </div> : null}
//         {/* {(progress || progress === 0)&& <div className="flex max-width">
//             <div id="total-progress-bar" className="max-width">
//                 <div id="actual-progress-bar" style={{ borderTop: `.1875em solid blue`, width: `${progress}%` }}></div>
//             </div>
//         </div>} */}
//     </div >
// )
export const modelUploadProgressBars = (text, progress) => (
    <div id="progress-bars-container" className="flex-centered" style={{width: '80%', marginRight: '1em'}}>
       {text ? <span id="file-manager-item-progress">{text}</span> : null}
       {progress && <div className="flex max-width">
           <div id="progress-bars" className="max-width">
               <div id="total-progress-bar" className="max-width">
                   <div id="actual-progress-bar" style={{ borderTop: `.1875em solid blue`, width: `${progress}%` }}></div>
               </div>
           </div>
       </div>}
   </div >
)

// button displayed when a model is ready to be reviewed
export const reviewButton = (cb) => {
    return <li id="review-button-container" className="flex-centered">
        <span className="clickable" id="review-button" onClick={cb}>Review Decimation</span>
    </li>
}

export const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export const toggleSorting = (stateValue, cb) => {
    if (stateValue === 2) {
        cb(0)
    } else {
        cb(stateValue + 1)
    }
}

/**
 * 
 * @param {} time 
 */
export const abbreviateTime = (time) => {
    if (time.includes("hour")) {
        let amount = time.split("hour")[0]
        if (amount.includes("a")) {
            amount = 1
        }
        return `${amount} hr`
    } else if (time.includes("minute")) {
        let amount = time.split("minute")[0]
        if (amount.includes("a")) {
            amount = 1
        }
        return `${amount} min`
    } else if (time.includes("second")) {
        let amount = time.split("second")[0]
        return `${amount} sec`
    } else if (time.includes("day")) {
        let amount = time.split("day")[0]
        // if (amount === "a") {
        if (amount.includes("a")) {
            amount = 1
        }
        return `${amount} d`
    } else if (time.includes("month")) {
        let amount = time.split("month")[0]
        if (amount.includes("a")) {
            amount = 1
        }
        return `${amount} mo`
    } else if (time.includes("year")) {
        let amount = time.split("year")[0]
        return `${amount} yr`
    }
}

export const findExtension = (filepath) => {
    if (typeof filepath == "undefined" || filepath == null )
    {
        return "zzz"
    }else{

        //fbx|FBX|dwg|DWG|glb|GLB|3DXML|3Dxml|jt|JT|stl|STL|usdz|USDZ|STP|stp|step|STEP
    let regex = new RegExp(/.(table|png|PNG|tiff|TIFF|jpg|JPG|jpeg|JPEG|mp4|MP4|MOV|mov|mp3|MP3|pdf|PDF|obj|OBJ|fbx|FBX|stl|STL|ply|PLY|gltf|GLTF|glb|GLB)$/)
    let match = filepath.match(regex)
  
    return match ? match[0].slice(1) : null
}
}

export const isAudio = (ext) => (audioExtensions.includes(ext))
export const isVideo = (ext) => (videoExtensions.includes(ext))
export const isDocument = (ext) => (documentExtensions.includes(ext))
export const isImage = (ext) => (imageExtensions.includes(ext))
export const isModel = (ext) => (modelExtensions.includes(ext))

export const renderTypeIcon = ext => {
    let icon
    if (isAudio(ext)) {
        icon = audioAttachmentSmall
    } else if (isVideo(ext)) {
        icon = videoAttachmentSmall
    } else if (isImage(ext)) {
        icon = imageAttachmentSmall
    } else if (isDocument(ext)) {
        icon = pdfAttachmentSmall
    } else if (isModel(ext)) {
        icon = modelAttachmentSmall
    } else {
        icon = unknownAttachment
    }
    return icon
}

export const renderDateAndTime = (dateData) => {
    return <span className="flex-centered">
            {moment(dateData).format('MM/DD/YYYY @ HHmm')}
        </span>
}